module.exports = __webpack_public_path__ + "0c89c65e39f6929cce4ce9d00dfbfd73.png";